import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { api } from '@/lib/api';
import { queryClient } from '@/lib/queryClient';
import type { Device } from '@/lib/types';
import { useWebSocket } from './useWebSocket';

export function useDevices() {
  const q = useQuery({
    queryKey: ['devices'],
    queryFn: () => api<Device[]>('/api/devices'),
    refetchInterval: 30_000,
  });

  // WS pushes update online state in-place without refetching.
  useWebSocket((msg) => {
    if (msg.type === 'device-status' || msg.type === 'device-offline') {
      queryClient.setQueryData<Device[] | undefined>(['devices'], (prev) => {
        if (!prev) return prev;
        const isOnline = msg.type === 'device-status';
        return prev.map((d) => d.client_id === msg.clientId ? { ...d, online: isOnline } : d);
      });
    }
  });

  // Refetch list once on mount in case WS state lags.
  useEffect(() => { q.refetch(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  return q;
}
